import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { JwtService } from '../services/jwt.service';

export const deviceGuard: CanActivateFn = () => {
  const jwtService = inject(JwtService);
  const router = inject(Router);

  // Allow access only if user has a valid device token but no employee token
  if (jwtService.deviceToken && !jwtService.isDeviceTokenExpired() && !jwtService.jwtToken) {
    return true;
  }

  // If no device token or device token expired, redirect to login
  if (!jwtService.deviceToken || jwtService.isDeviceTokenExpired()) {
    router.navigateByUrl('/login');
    return false;
  }

  // If user already has employee token, redirect to dashboard
  if (jwtService.jwtToken && !jwtService.isTokenExpired()) {
    router.navigateByUrl('/dashboard');
    return false;
  }

  // Default: redirect to login
  router.navigateByUrl('/login');
  return false;
};
